// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__119aM","colMin":"styles_colMin__QImbT"};